module.exports = __webpack_public_path__ + "img/slide_next_white.b6c96d67.png";